import React from 'react'

import Horizontal from '../layouts/Horizontal.jsx'
import PieChartHOC from '../charts/PieChartHOC.jsx'
import Card from '../components/Card.jsx'
import ZeroState from '../components/ZeroState.jsx'
import LoadingState from '../components/LoadingState.jsx'

import { formatEntityComparison, useFetchDistribution } from './CompetitiveLandscape.jsx'

const EntityComparison = (props) => {
  const {
    audience: { _id: audienceId },
  } = props
  const { title, description, section_1, selected_entities } = props.data

  const entities = selected_entities.map((entity) => {
    if (typeof entity === 'string') return entity
    return entity.orig_name
  })

  const { data, loading } = useFetchDistribution(audienceId, entities)

  const pieChartData = formatEntityComparison(data, entities)

  return (
    <Horizontal
      title={title}
      description={description}
      page={props.index + 1}
      content={() => (
        <Card title={section_1.title} description={section_1.subtitle} showBorder={false}>
          <Choose>
            <When condition={loading}>
              <LoadingState />
            </When>
            <Otherwise>
              <ZeroState condition={!!pieChartData?.length}>
                <PieChartHOC data={pieChartData} legendPosition="bottom" />
              </ZeroState>
            </Otherwise>
          </Choose>
        </Card>
      )}
    />
  )
}

export default EntityComparison
